import { take } from "rxjs/operators";
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import type { MultiSelectChangeEvent } from "primeng/multiselect";
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';

@Component({
    selector: 'medsurf-slide-edit-shared-poi-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './shared-poi-form.component.html',
    styleUrls: ['./shared-poi-form.component.scss'],
    standalone: false
})
export class SharedPoiFormComponent {
  #annotation: FlatModels.AnnotationEntityModels.AnnotationEntityType | null;
  #poiIds: string[];
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
                     public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Annotation
    this.slideAuthorFacade.currentSelectedSlideAnnotation$.pipe(takeUntilDestroyed()).subscribe((annotation) => {
      this.#annotation = annotation;
      this.#updatePoiIds();
    });
  }
  
  #updatePoiIds() {
    if (this.#annotation) {
      this.slideAuthorFacade.poiIdsByAnnotation$(this.#annotation.id).pipe(take(1)).subscribe((poiIds) => {
        this.#poiIds = poiIds;
      });
    } else {
      this.#poiIds = [];
    }
  }
  
  onChange(event: MultiSelectChangeEvent) {
    if (!this.#annotation) return;
    const poisToAdd = event.value.filter((v: string) => !this.#poiIds.includes(v));
    const poisToRemove = this.#poiIds.filter(v => !event.value.includes(v));
    
    if (poisToAdd.length > 0) {
      this.slideAuthorFacade.requestAddAnnotationIdToPois(poisToAdd, this.#annotation.id, 'history.annotation_add_to_pois').subscribe({
        error: (result) => this.alertControlFacade.requestAddError(result),
        next: () => this.#updatePoiIds()
      });
    } else if (poisToRemove.length > 0) {
      this.slideAuthorFacade.requestRemoveAnnotationFromPois(poisToRemove, this.#annotation.id, 'history.annotation_remove_from_pois').subscribe({
        error: (result) => this.alertControlFacade.requestAddError(result),
        next: () => this.#updatePoiIds()
      });
    }
  }
}
